<template>
  <div class="md-layout page-flight-review-booking">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="banner">
        {{ $t("Looking to acquire a high-quality drone at a great price?") }}
        <a
          class="contect-btn"
          target="_blank"
          href="mailto:sales@aimrobotics.io"
        >
          Contact us now!
        </a>
      </md-toolbar>
      <br />
    </div>

    <div class="md-layout-item md-xsmall-size-100 mx-auto">
      <simple-wizard @tab-change="onTabChange" :startIndex="startIndex">
        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">{{ $t("Step 1: Select Reviewer") }}</template>
          <first-step
            ref="step1"
            @on-validated="onStepOneValidated"
          ></first-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">{{ $t("Step 2: Pick Review Time") }}</template>
          <second-step
            ref="step2"
            @on-validated="onStepTwoValidated"
          ></second-step>
        </wizard-tab>
        <wizard-tab :before-change="() => validateStep('step3')">
          <template slot="label">{{ $t("Step 3: Payment") }}</template>
          <third-step
            ref="step3"
            @on-validated="onStepThreeValidated"
          ></third-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step4')">
          <template slot="label">{{ $t("Step 4: Submission") }}</template>
          <fourth-step ref="step4"></fourth-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from "./BookingWizard/FirstStep.vue";
import SecondStep from "./BookingWizard/SecondStep.vue";
import ThirdStep from "./BookingWizard/ThirdStep.vue";
import FourthStep from "./BookingWizard/FourthStep.vue";
import { mapFields } from "vuex-map-fields";
import { SimpleWizard, WizardTab } from "@/components";
import swal from "sweetalert2";
import { PILOT_NETWORK } from "@/const";
import { findBooking } from "@/services/flightReview.service.js";

export default {
  data() {
    return {
      wizardModel: {},
      startIndex: 0
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    SimpleWizard,
    WizardTab
  },
  computed: {
    ...mapFields("flightReview", ["booking"]),
    ...mapFields("setting", ["pilotQuantity", "droneQuantity"])
  },
  mounted() {
    if (this.startIndex === 0) {
      setTimeout(this.$refs["step1"].initMap, 40);
    }
    let _self = this;
    this.$store.dispatch("setting/getSettings").then(() => {
      if (this.pilotQuantity > 0 && this.droneQuantity > 0) return;
      swal
        .fire({
          title: this.$t("Warning"),
          text: this.$t("No pilot or drone information has been added."),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        })
        .then(() => {
          _self.$router.replace("/flight-review/requirement");
        });
    });

    // get booking list, check booking status
    this.checkBookingStatus()
  },
  beforeMount() {
    if (sessionStorage.getItem("reviewerInfo")) {
      // before user signup and already select reviewer, show select detail
      const reviewerInfo = JSON.parse(sessionStorage.getItem("reviewerInfo"));
      this.$store.commit("flightReview/updateBooking", {
        reviewerId:
          reviewerInfo.pilot_network === PILOT_NETWORK.MAAC_CLUB
            ? ""
            : reviewerInfo._id.$oid,
        clubId:
          reviewerInfo.pilot_network === PILOT_NETWORK.MAAC_CLUB
            ? reviewerInfo._id.$oid
            : ""
      });
      // this.startIndex = 1;
      sessionStorage.removeItem("reviewerInfo");
    }
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onTabChange(oldTab, newTab) {
      this.$refs["step2"].showCalendarFn(false);
      if (newTab.tabId === "0") {
        setTimeout(this.$refs["step1"].initMap, 40);
      }
      if (newTab.tabId === "1") {
        setTimeout(() => {
          this.$refs["step2"].showCalendarFn(true);
        }, 40);
      }
    },
    onStepOneValidated() {
      // if (validated) {}
    },
    onStepTwoValidated() {},
    onStepThreeValidated() {},
    async checkBookingStatus() {
      const bookingList = await findBooking();
      const hrs48 = +new Date() + 48 * 60 * 60 * 1000 // 48 hours
      const ongoingOrders = bookingList.filter(item => +item.event_status === 0 || +item.event_status === 4)
      if (ongoingOrders.length === 0) {
        return
      }
      let _self = this;
      swal
        .fire({
          title: this.$t("Warning"),
          text: this.$t("You have an ongoing order. Rebooking will incur additional fees. Are you sure you want to continue?"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonClass: "md-button md-danger",
          cancelButtonClass: "md-button md-success",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Go to Booking list"),
        })
        .then(({value}) => {
          if (!value) {
            _self.$router.push("/flight-review/bookingList");
          }
        });
    }
  }
};
</script>

<style lang="scss">
.page-flight-review-booking {
  .md-toolbar {
    z-index: 1;
  }
  .banner {
    background-image: url("/img/bg-space.gif");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .contect-btn {
    margin-left: 12px;
    font-size: 16px;
  }
}
</style>
